module.exports = __webpack_public_path__ + "static/media/bet-popup.65d87fd1.png";